import React from 'react';

export var ClosedCaptionIcon = function ClosedCaptionIcon(props) {
  return React.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 2400 2400" },
    React.createElement("path", {
      fill: props.fillColor,
      d: "M1900 400 h-1400 c-111 0 -200 90 -200 200 v1200 c0 110 89 200 200 200 h1400 c110 0 200 -90 200 -200 v-1200 c0 -110 -90 -200 -200 -200 z M1900 1800 h-1400 v-1200 h1400 v1200 z M730 1500 h300 c55 0 100 -45 100 -100 v-100 h-150 v50 h-200 v-300 h200 v50 h150 v-100 c0 -55 -45 -100 -100 -100 h-300 c-55 0 -100 45 -100 100 v400 c0 55 45 100 100 100 z M1370 1500 h300 c55 0 100 -45 100 -100 v-100 h-150 v50 h-200 v-300 h200 v50 h150 v-100 c0 -55 -45 -100 -100 -100 h-300 c-55 0 -100 45 -100 100 v400 c0 55 45 100 100 100 z"
    })
  );
};